import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { transactionAPI } from "services";
import ModalImage from "react-modal-image";
import { ConfirmationModal } from "components";
import useUniversalStore from "store/universalStore";
import { formatMoney } from "utils";
import useOffcanvasStore from "store/offcanvasStore";
import { toast } from "sonner";

const Txn = ({ data, setLoading }) => {
  const { accountId, transactionId, write, selectedMonth } = useUniversalStore((state) => state);

  const isPDF = data.get("attachment")?.includes(".pdf");
  const isImage = data.get("attachment")?.match(/\.(jpg|jpeg|png|gif|webp)$/i);
  const navigate = useNavigate();
  const { openOffcanvas } = useOffcanvasStore();
  const text = data.get("detail");

  const handleModalOpen = () => {
    const modal = new window.bootstrap.Modal(document.getElementById('deleteTxnInCashbookModal'));
    modal.show();
  };

  //method to navigate home page and auto select the khatha account
  const openKhataView = async () => {
    const accountId = data?.get("accountId")?.id;
    if (!accountId) return;

    if (data.get("accountId")?.get("cancelled")) {
      toast.error("Account is Closed");
      return;
    };
    write({ accountId: accountId });
    navigate("/khatabook");
  };

  const deleteTransaction = async () => {
    try {
      setLoading(true)
      await transactionAPI.deleteTransaction(transactionId);
      //Reset the transactionId
      write({
        transactionId: null,
        transactions: await transactionAPI.getTransactionsByDate(selectedMonth)
      });
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false)
    }
  }

  const cancelledView = () => {
    return (
      <div className="d-flex pe-0 p-md-0 justify-content-center align-items-start">
        <div className="col-4 col-md-3 pe-0 text-end" style={{ minWidth: "min-content" }}>
          <i className="fs-xmd-smaller text-nowrap text-decoration-line-through text-muted">
            {formatMoney(data.get("amount"))}
          </i>
        </div>
        <div className="col-8 col-md-9 ps-2">
          <div className="d-flex flex-wrap col-12">
            <div className="col-12 text-start">
              {data.get("accountId") ? (
                <div className="row">
                  <div className="col text-start">
                    <a className="text-decoration-line-through text-muted pe-none">
                      {data.get("accountId")?.get("name")}
                    </a>
                  </div>
                </div>
              ) : null}
              <small className="text-break text-wrap text-decoration-line-through text-muted">{data.get("detail")}</small>
              <div align="right">
                <small align="right"><i className="text-decoration-line-through text-muted">{dayjs(data.get("date")).format('DD MMM')}</i></small>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const normalView = () => {
    return (
      <div className="d-flex pe-0 p-md-0 justify-content-center align-items-start">
        <div className="col-4 col-md-3 pe-0 text-end" style={{ minWidth: "min-content" }}>
          <i className="text-decoration-none text-color-format fs-xmd-smaller text-nowrap">
            {formatMoney(Math.abs(data.get("amount")))}
          </i>
        </div>
        <div className="col-8 col-md-9 ps-2">
          <div className="d-flex flex-wrap col-12">
            <div className="col-12 text-start">
              <div className="flex-fill">
                {data.get("accountId") ? (
                  <a onClick={openKhataView}
                    type="button"
                    className="text-decoration-none pe-auto fw-bold fst-italic text-dark fs-xmd-smaller d-block select-none">
                    {data.get("accountId")?.get("name")}
                  </a>
                ) : null}
                <div className="fs-xmd-smaller">
                  <small className="text-break text-wrap">{text}</small>
                </div>
              </div>
            </div>
            <div className="col-12 d-flex justify-content-end align-items-center">
              <div>
                <small><i>{dayjs(data.get("date")).format('DD MMM')}</i></small>
              </div>
              {/* Dropdown to edit and delete the transaction */}
              <div className="ps-2">
                <div className="dropdown">
                  <a
                    className="text-black btn p-0 p-md-1 bg-not-transparent-on-hover w-auto"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    title="More options"
                  >
                    <span className="bi bi-three-dots-vertical"></span>
                  </a>
                  <ul className="dropdown-menu dropdown-menu-end row w-auto">
                    <li className="col-12 py-1">
                      <button className="w-100 btn btn-outline-app rounded"
                        onClick={() => {
                          write({ transactionId: data.id })
                          openOffcanvas("editTxn")
                        }}
                      >
                        <span className="bi bi-pencil-fill"> Edit</span>
                      </button>
                    </li>
                    <li className="col-12 py-1">
                      <button
                        className="w-100 btn btn-app rounded"
                        onClick={() => {
                          write({ transactionId: data.id })
                          handleModalOpen()
                        }}
                      >
                        <span className="bi bi-trash"> Delete</span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-12">
              {(isImage || isPDF) && <div className="row text-start">
                <div className="col-12">
                  {isPDF && (
                    <a role="button"
                      href={data.get("attachment")}
                      target="_blank"
                      className="cursor-pointer">
                      <i className="bi bi-file-pdf-fill text-app fs-1" />
                    </a>
                  )}

                  {isImage && (
                    <ModalImage
                      small={data.get("attachment")}
                      large={data.get("attachment")}
                      hideDownload={false}
                      hideZoom={false}
                      className="uploadbillpreview"
                    />
                  )}
                </div>
              </div>}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="list-group-item bg-transparent">
      <div className="row align-items-baseline">
        {data.get("cancelled") ? cancelledView() : normalView()}
        <ConfirmationModal id="deleteTxnInCashbookModal" onClick={deleteTransaction} />
      </div>
    </div>
  );
}

export default Txn;
